import { RouterFocusLink } from "./RouterLink";

export default RouterFocusLink;
